// src/api/admin/lenderShortlistPercentage.js
import { api } from "../client";
import { API_BASE_URL } from "../../utils/constants";

const METHOD_PATH = `${API_BASE_URL}/api/method/dynesourcerapi.shortlist_api.lender_shortlist_percentage`;

/**
 * Get shortlisted product % per lender for Analytics Lender Intelligence.
 * Response: { message: { from_date, to_date, statuses, page, page_size, total_lenders, data: [{ lender_user, lender_name, total_products, shortlisted_distinct_products, shortlist_percentage, ... }] } }
 *
 * @param {Object} params - Query parameters
 * @param {string} [params.from_date] - Start date (YYYY-MM-DD)
 * @param {string} [params.to_date] - End date (YYYY-MM-DD)
 * @param {string|string[]} [params.statuses] - e.g. "Pending,Approved,Rejected" or array
 * @param {number} [params.page=1]
 * @param {number} [params.page_size=50]
 * @returns {Promise<{ data: Array, total_lenders: number, from_date: string, to_date: string }>}
 */
export async function getLenderShortlistPercentage(params = {}) {
  const q = { ...params };
  if (Array.isArray(q.statuses)) {
    q.statuses = q.statuses.join(",");
  }
  const response = await api.get(METHOD_PATH, { params: q });
  const raw = response?.data?.message ?? response?.data;

  const data = raw?.data ?? (Array.isArray(raw) ? raw : []);
  const total_lenders = raw?.total_lenders ?? data.length;
  return {
    data: Array.isArray(data) ? data : [],
    total_lenders,
    from_date: raw?.from_date ?? "",
    to_date: raw?.to_date ?? "",
  };
}

export default getLenderShortlistPercentage;
